import React, { useState } from 'react';
import './SearchBar.css';

const SearchBar = ({ onSearchChange }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    onSearchChange(term);
  };

  const handleClearSearch = () => {
    setSearchTerm('');
    onSearchChange('');
  };

  return (
    <div className="search-bar">
      <div className="search-input-wrapper">
        <input
          type="text"
          placeholder="Search games..."
          value={searchTerm}
          onChange={handleSearchChange}
          className="search-input"
        />
        {searchTerm && (
          <button
            onClick={handleClearSearch}
            className="clear-search-button"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
